import { on } from '@ember/modifier';
import { action } from '@ember/object';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import SettingsPanel from 'garaje/components/ui/classic/settings-panel';
import type LocationModel from 'garaje/models/location';

interface HostSignOutReminderSignature {
  Args: {
    currentLocation: LocationModel;
  };
}

export default class HostSignOutReminder extends Component<HostSignOutReminderSignature> {
  @tracked isOpen = false;

  @action
  enable(): void {
    this.isOpen = true;
  }

  @action
  cancel(): void {
    this.isOpen = false;
  }

  <template>
    <SettingsPanel @isOpen={{this.isOpen}} data-test-host-sign-out-reminder as |sp|>
      {{#let sp.header as |PanelHeader|}}
        <PanelHeader
          @iconUri="/assets/images/features/signout.svg"
          @title="Host sign out reminder"
          @onCancel={{this.cancel}}
          as |header|
        >
          <header.description>
            Remind hosts to sign out their visitors.
          </header.description>
          <header.controls>
            {{#unless sp.isOpen}}
              <button
                data-test-enable-host-sign-out-reminder
                type="button"
                class="btn btn--small btn--brand"
                {{on "click" this.enable}}
              >
                Enable
              </button>
            {{/unless}}
          </header.controls>
        </PanelHeader>
      {{/let}}
    </SettingsPanel>
  </template>
}
